import { IWebhookModel } from '../model';

export default (self: IWebhookModel) => ({
  get searchString() {
    const { url, auth } = self;
    return [url, auth].join(' ').toLowerCase();
  }
});
